import * as React from "react";
import {EditButton} from "react-admin";
import {Link} from "react-router-dom";
import {DeleteWithConfirmationModalButton} from "../../../Component/Redesign/DeleteWithConfirmationModalButton";

const CalendarEventActions = ({id, record}) => (
    <div className="crud-mode">
        <EditButton id={id} record={record} label="" />
        <Link
            to={`/calendar-events/${id}/configure-button`}
            className="calendar-event-configure-button"
        >
            Configure Button
        </Link>
        <DeleteWithConfirmationModalButton undoable={false} id={id} record={record} label="" />
    </div>
);

export default CalendarEventActions;
